(function () {
  var root = document.querySelector('.cl-home');
  if (!root) { return; }

  /* ---------- testimonial carousel ---------- */
  var car = root.querySelector('[data-cl-carousel]');
  if (car) {
    var track = car.querySelector('[data-cl-track]');
    var slides = Array.prototype.slice.call(track.querySelectorAll('.cl-quotes__slide'));
    var dotsWrap = car.querySelector('[data-cl-dots]');
    var delay = parseInt(car.getAttribute('data-autoplay'), 10) || 10000;
    var index = 0;
    var timer = null;

    slides.forEach(function (_, i) {
      var b = document.createElement('button');
      b.type = 'button';
      b.setAttribute('role', 'tab');
      b.setAttribute('aria-label', 'Testimonial ' + (i + 1));
      b.addEventListener('click', function () { go(i, true); });
      dotsWrap.appendChild(b);
    });
    var dots = Array.prototype.slice.call(dotsWrap.children);

    function mark() {
      dots.forEach(function (d, i) { d.setAttribute('aria-current', i === index ? 'true' : 'false'); });
    }

    function go(i, userInitiated) {
      index = (i + slides.length) % slides.length;
      track.scrollTo({ left: slides[index].offsetLeft - track.offsetLeft, behavior: 'smooth' });
      mark();
      if (userInitiated) { restart(); }
    }

    function restart() { stop(); start(); }
    function start() { if (!timer) { timer = setInterval(function () { go(index + 1); }, delay); } }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }

    car.querySelector('[data-cl-prev]').addEventListener('click', function () { go(index - 1, true); });
    car.querySelector('[data-cl-next]').addEventListener('click', function () { go(index + 1, true); });
    car.addEventListener('mouseenter', stop);
    car.addEventListener('mouseleave', start);
    car.addEventListener('focusin', stop);

    var scrollTick;
    track.addEventListener('scroll', function () {
      clearTimeout(scrollTick);
      scrollTick = setTimeout(function () {
        var nearest = 0;
        var best = Infinity;
        slides.forEach(function (s, i) {
          var d = Math.abs(s.offsetLeft - track.offsetLeft - track.scrollLeft);
          if (d < best) { best = d; nearest = i; }
        });
        index = nearest;
        mark();
      }, 120);
    }, { passive: true });

    mark();
    if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) { start(); }
  }

  /* ---------- FAQ: one-open-at-a-time fallback for browsers
                   without exclusive <details name=""> support ---------- */
  if (!('name' in document.createElement('details'))) {
    var items = Array.prototype.slice.call(root.querySelectorAll('.cl-faq__item'));
    items.forEach(function (d) {
      d.addEventListener('toggle', function () {
        if (!d.open) { return; }
        items.forEach(function (o) { if (o !== d) { o.open = false; } });
      });
    });
  }

  /* ---------- video modal ---------- */
  var modal = root.querySelector('[data-cl-video-modal]');
  if (modal) {
    var vid = modal.querySelector('[data-cl-video-el]');
    var opener = root.querySelector('[data-cl-video-open]');

    function closeVideo() {
      vid.pause();
      if (modal.open) { modal.close(); }
    }

    opener.addEventListener('click', function () {
      if (typeof modal.showModal === 'function') {
        modal.showModal();
        vid.play().catch(function () { /* autoplay blocked — user can press play */ });
      } else {
        window.open(vid.src, '_blank', 'noopener');
      }
    });
    modal.querySelector('[data-cl-video-close]').addEventListener('click', closeVideo);
    modal.addEventListener('close', function () { vid.pause(); });
    modal.addEventListener('click', function (e) { if (e.target === modal) { closeVideo(); } });
  }
})();
